import { HttpServiceBase } from "../../../common-services/Http/HttpServiceBase";
import { Result } from "../../../common-models/Result";
import { ConsultTrackingOrderInput } from "./ConsultTrackingOrderInput";
import { ConsultTrackingOrderOutput } from "./ConsultTrackingOrderOutput";

export class ConsultTrackingOrderService extends HttpServiceBase {

  handle = (input: ConsultTrackingOrderInput): Promise<Result<ConsultTrackingOrderOutput> | null> => {
    const promise = this.http.get<Result<ConsultTrackingOrderOutput>>(`${this.baseUrlSislogApi}/v2/carrier/consult-tracking-order/${input.orderId}`);
    return promise;
  }
}